// src/components/inventory/FormField.js
import React from "react";

const FormField = React.memo(({ label, required, error, children, classApplied = "" }) => (
  <div className={classApplied}>
    {label && (
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
    )}
    {/* Remove the relative div wrapper */}
    {children}
    {error && (
      <p className="text-red-500 text-xs mt-0.5 flex items-center gap-1">
        <span>⚠️</span> {error}
      </p>
    )}
  </div>
));
FormField.displayName = "FormField";

// ─── Input className helper ───────────────────────────────────────────────────
export const inputCls = (hasError) =>
  `block w-full p-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${
    hasError ? "border-red-500 ring-2 ring-red-200" : "border-gray-300"
  }`;

export default FormField;